module.exports = "/assets/a260a51c111306a30990a4f3c3cc6d0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/nophoto/hotels.jpg
// module id = 85
// module chunks = 0